var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-content detail-content body-payment"},[_vm._v(" 購入ありがとうございました ")])
}
var staticRenderFns = []

export { render, staticRenderFns }